import { apiClient } from './api/apiClient';
import { ApiResponse } from '../types';

export interface Prize {
  id: number;
  companyId: number;
  name: string;
  description?: string;
  pointsCost: number;
  imageUrl?: string;
  sortOrder: number;
  isActive: boolean;
  createdAt: string;
}

export interface CreatePrizeRequest {
  name: string;
  description?: string;
  pointsCost: number;
  imageUrl?: string;
  sortOrder?: number;
}

export interface UpdatePrizeRequest {
  name?: string;
  description?: string;
  pointsCost?: number;
  imageUrl?: string;
  sortOrder?: number;
  isActive?: boolean;
}

class PrizeService {
  /**
   * Ottieni lista premi per azienda
   */
  async getPrizes(companyId: number): Promise<Prize[]> {
    return await apiClient.get<Prize[]>(`/prizes/${companyId}`);
  }

  /**
   * Crea nuovo premio
   */
  async createPrize(data: CreatePrizeRequest): Promise<ApiResponse<Prize>> {
    return await apiClient.post<ApiResponse<Prize>>('/prizes', data);
  }

  /**
   * Aggiorna premio esistente
   */
  async updatePrize(id: number, data: UpdatePrizeRequest): Promise<ApiResponse<Prize>> {
    return await apiClient.put<ApiResponse<Prize>>(`/prizes/${id}`, data);
  }

  /**
   * Elimina premio (soft delete)
   */
  async deletePrize(id: number): Promise<void> {
    return await apiClient.delete(`/prizes/${id}`);
  }
}

export const prizeService = new PrizeService();
